<div *ngIf="totalProgress" class="progress-bar-container" [ngClass]="{ 'ion-padding-vertical': verticalSpacing }">
    <p class="sr-only">Step {{ currentProgress || 1 }} out of {{ totalProgress }}</p>

    <div
        *ngFor="let count of counterArray"
        class="progress-bar-step"
        [ngClass]="{ 'progress-bar-step-active': count <= (currentProgress || 1) }"></div>
</div>
